import { Link } from "@inertiajs/react"

import { sitePath } from "@/routes"
import type { SiteCard as SiteCardData } from "@/types/site"

import { DecadeBadge } from "./decade-badge"
import { Screenshot } from "./screenshot"
import { StatusPill } from "./status-pill"

export function SiteCard({
  site,
  eager = false,
}: {
  site: SiteCardData
  eager?: boolean
}) {
  const archived = site.status === "dead" || site.status === "parked"
  return (
    <Link
      href={sitePath(site.slug)}
      prefetch="hover"
      className="group bg-card focus-visible:ring-ring flex flex-col overflow-hidden rounded-2xl border shadow-[0_1px_2px_rgb(28_25_23/0.04)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_12px_32px_-12px_rgb(28_25_23/0.25)] focus-visible:ring-2 focus-visible:outline-none"
    >
      <div className="relative">
        <Screenshot
          src={site.thumbnail_url}
          host={site.host}
          source={site.screenshot_source}
          alt={`Screenshot of ${site.host}`}
          eager={eager}
          className={archived ? "grayscale-[0.6]" : undefined}
        />
        {site.status !== "up" && (
          <StatusPill
            status={site.status}
            overlay
            className="absolute top-2.5 right-2.5"
          />
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-start justify-between gap-3">
          <h3 className="line-clamp-2 leading-snug font-bold">{site.title}</h3>
          <DecadeBadge decade={site.decade} className="mt-0.5 shrink-0" />
        </div>
        {site.description && (
          <p className="text-muted-foreground line-clamp-2 text-sm">
            {site.description}
          </p>
        )}
        <div className="text-muted-foreground mt-auto flex items-center gap-2 pt-1 text-xs">
          <span className="bg-muted max-w-[60%] truncate rounded px-1.5 py-0.5 font-mono text-[11px]">
            {site.host}
          </span>
          {site.author_name && (
            <span className="truncate">by {site.author_name}</span>
          )}
        </div>
      </div>
    </Link>
  )
}
